/* ============================================================
   FORMABOX — course search suggestions
   Asks Shopify's predictive search as the buyer types and lists the
   matching courses under the bar. Arrow keys move through them, Enter
   opens one, Escape closes the list. Enter with nothing highlighted
   submits the form to the full search page.
   ============================================================ */
(function () {
  'use strict';

  var form = document.querySelector('.csearch');
  if (!form || !window.fetch) return;

  var input  = form.querySelector('.csearch__input');
  var panel  = form.querySelector('.csearch__panel');
  var list   = form.querySelector('.csearch__list');
  var status = form.querySelector('.csearch__status');
  var url    = form.getAttribute('data-suggest-url') || '/search/suggest';

  var cache = {};
  var active = -1;
  var timer, ctrl;

  var money = (function () {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CAD';
    try { return new Intl.NumberFormat('en-CA', { style: 'currency', currency: cur }); }
    catch (e) { return { format: function (n) { return '$' + Number(n).toFixed(2); } }; }
  })();

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Bold the part of the title the buyer typed.
  function mark(title, q) {
    var i = title.toLowerCase().indexOf(q.toLowerCase());
    if (!q || i < 0) return esc(title);
    return esc(title.slice(0, i)) + '<mark>' + esc(title.slice(i, i + q.length)) + '</mark>' + esc(title.slice(i + q.length));
  }

  function creator(p) {
    var v = (p.vendor || '').trim();
    return /^(unknown|various creators)$/i.test(v) ? '' : v;
  }

  function open(on) {
    panel.hidden = !on;
    input.setAttribute('aria-expanded', on ? 'true' : 'false');
    form.classList.toggle('is-open', on);
    if (!on) setActive(-1);
  }

  function options() { return list.querySelectorAll('[role="option"]'); }

  function setActive(i) {
    var opts = options();
    if (active > -1 && opts[active]) opts[active].setAttribute('aria-selected', 'false');
    active = i;
    if (i > -1 && opts[i]) {
      opts[i].setAttribute('aria-selected', 'true');
      input.setAttribute('aria-activedescendant', opts[i].id);
      opts[i].scrollIntoView({ block: 'nearest' });
    } else {
      input.removeAttribute('aria-activedescendant');
    }
  }

  function render(q, products) {
    var html = products.map(function (p, i) {
      var img = p.featured_image && p.featured_image.url
        ? '<img src="' + esc(p.featured_image.url) + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="" width="80" height="45" loading="lazy">'
        : '<span class="csearch__ph"></span>';
      var by = creator(p);
      var price = p.price != null && p.price !== '' ? money.format(parseFloat(p.price)) : '';
      return '<li role="option" id="csearch-opt-' + i + '" aria-selected="false">' +
        '<a class="csearch__item" href="' + esc(p.url) + '" tabindex="-1">' +
          '<span class="csearch__thumb">' + img + '</span>' +
          '<span class="csearch__text"><span class="csearch__title">' + mark(p.title, q) + '</span>' +
          (by ? '<span class="csearch__by">' + esc(by) + '</span>' : '') + '</span>' +
          (price ? '<span class="csearch__price">' + esc(price) + '</span>' : '') +
        '</a></li>';
    }).join('');

    html += '<li role="option" id="csearch-opt-all" aria-selected="false">' +
      '<a class="csearch__all" href="' + esc(form.action) + '?type=product&q=' + encodeURIComponent(q) + '" tabindex="-1">' +
      'See every result for “' + esc(q) + '”</a></li>';

    list.innerHTML = html;
    active = -1;
    status.textContent = products.length
      ? products.length + (products.length === 1 ? ' course suggested' : ' courses suggested')
      : 'No course matches “' + q + '”. Try a creator’s name or a method like ICT or order flow.';
    status.classList.toggle('is-empty', !products.length);
    open(true);
  }

  function query(q) {
    if (cache[q]) return render(q, cache[q]);
    if (ctrl) ctrl.abort();
    ctrl = window.AbortController ? new AbortController() : null;

    var params = 'q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=6&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,vendor,product_type,tag,variants.title';

    fetch(url + '.json?' + params, ctrl ? { signal: ctrl.signal } : {})
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        cache[q] = products;
        if (input.value.trim() === q) render(q, products);
      })
      .catch(function (e) { if (e.name !== 'AbortError') open(false); });
  }

  input.addEventListener('input', function () {
    var q = input.value.trim();
    clearTimeout(timer);
    if (!q) { open(false); list.innerHTML = ''; return; }
    timer = setTimeout(function () { query(q); }, 140);
  });

  input.addEventListener('focus', function () {
    if (input.value.trim() && list.children.length) open(true);
  });

  input.addEventListener('keydown', function (e) {
    var opts = options();
    if (e.key === 'ArrowDown' && opts.length) {
      e.preventDefault();
      if (panel.hidden) open(true);
      setActive(active + 1 >= opts.length ? 0 : active + 1);
    } else if (e.key === 'ArrowUp' && opts.length) {
      e.preventDefault();
      setActive(active - 1 < 0 ? opts.length - 1 : active - 1);
    } else if (e.key === 'Enter' && active > -1 && opts[active]) {
      e.preventDefault();
      window.location.href = opts[active].querySelector('a').href;
    } else if (e.key === 'Escape') {
      if (!panel.hidden) { e.preventDefault(); open(false); }
    }
  });

  list.addEventListener('mousemove', function (e) {
    var li = e.target.closest('[role="option"]');
    if (!li) return;
    var i = Array.prototype.indexOf.call(options(), li);
    if (i !== active) setActive(i);
  });

  document.addEventListener('click', function (e) {
    if (!form.contains(e.target)) open(false);
  });

  // "/" jumps to the search from anywhere on the page, as on most stores.
  document.addEventListener('keydown', function (e) {
    if (e.key !== '/' || e.ctrlKey || e.metaKey || e.altKey) return;
    var t = e.target;
    if (t.isContentEditable || /^(input|textarea|select)$/i.test(t.tagName)) return;
    e.preventDefault();
    input.focus();
    input.select();
  });
})();
